import React, { useEffect, useState, useMemo } from "react";
import { Alert, Snackbar } from "@mui/material";

import Emitter from "utility/emitter";
import "./SnackbarMessage.css";
import { SHOW_SNACKBAR_MESSAGE } from "utility/emitterEvents";

type SeverityType = "error" | "info" | "success" | "warning";

export const SnackbarMessage: React.FC = () => {
	const [open, setOpen] = useState(false);
	const [messageInfo, setMessageInfo] = useState<React.ReactNode | string>("");
	const [severity, setSeverity] = useState<SeverityType>("error");

	const handleClose = (
		event: Event | React.SyntheticEvent<any, Event>,
		reason?: React.ReactNode | string
	) => {
		if (reason === "clickaway") {
			return;
		}
		setOpen(false);
		setMessageInfo("");
	};

	useEffect(() => {
		Emitter.on(
			SHOW_SNACKBAR_MESSAGE,
			(payload: {
				message: React.ReactNode | string;
				severityType: string;
			}) => {
				setOpen(false);
				setTimeout(() => {
					if (payload.message) {
						setOpen(true);
						setMessageInfo(payload.message);
					}
					setSeverity((payload.severityType as SeverityType) || "error");
				}, 50);
			}
		);
		return () => {
			Emitter.off(SHOW_SNACKBAR_MESSAGE, undefined);
		};
	}, []);

	const alertClass = useMemo(() => {
		if (severity === "warning") {
			return "warning";
		}
		if (severity === "success") {
			return "success";
		}
		if (severity === "info") {
			return "info";
		}
		return "alert-error";
	}, [severity]);

	return (
		<div>
			<Snackbar
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "right",
				}}
				open={open}
				onClose={handleClose}
				message={messageInfo}
				autoHideDuration={5000}
			>
				<Alert
					icon={false}
					onClose={handleClose}
					severity={severity}
					className={alertClass}
					variant="outlined"
				>
					{messageInfo}
				</Alert>
			</Snackbar>
		</div>
	);
};
